import React from 'react';
import PropTypes from 'prop-types';

import { Box, Card as BaseCard } from 'rebass';
import styled from 'styled-components';

import { Person } from '@oca/icons';

// eslint-disable-next-line import/no-cycle
import { Typography, Avatar } from '../atoms';

export const UserCard = React.forwardRef(
  /**
   *
   * @param {UserCardProps} props
   * @param {React.Ref} ref
   */
  function UserCard(props, ref) {
    const { avatar, title, name, subtitle, ...rest } = props;

    return (
      <Card width={215} py={3} px={2} {...rest} ref={ref}>
        <Box>
          <Avatar
            mb={3}
            size={48}
            src={avatar}
            style={{ border: '2px solid white' }}
          >
            <Person />
          </Avatar>
        </Box>
        {name && (
          <Typography
            fontWeight={500}
            width={1}
            fontSize={16}
            lineHeight={1}
            marginBottom={2}
          >
            {name}
          </Typography>
        )}
        {/* {title && (
          <Typography color="textSecondary" variant="h3">
            {title}
          </Typography>
        )} */}
        {subtitle && (
          <Typography color="textSecondary" lineHeight={1.3}>
            {subtitle}
          </Typography>
        )}
      </Card>
    );
  },
);

UserCard.propTypes = {
  ...BaseCard.propTypes,
  // eslint-disable-next-line react/require-default-props
  avatar: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.node,
  // eslint-disable-next-line react/require-default-props
  name: PropTypes.node,
  // eslint-disable-next-line react/require-default-props
  subtitle: PropTypes.node,
};

const Card = styled(BaseCard)`
  display: flex;
  flex-flow: column wrap;
  border-radius: 12px;
  padding: 16px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.cardFillSecondary};
`;

/**
 * @typedef {Object} CardProps
 * @property {string} avatar
 * @property {React.ReactNode} title
 * @property {React.ReactNode} subtitle
 * @property {React.ReactNode} name
 */

/**
 * @typedef {CardProps & import('rebass').BoxProps} UserCardProps
 */
